module.exports = __webpack_public_path__ + "static/media/bg2.c9fe7f2e.webp";